/*========================================================================
 * $Id$
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/

/*
 *
 * +-------+                          
 * | Model |                          
 * +-+-----+                          
 *   |
 *   +-> source_context.constraints.view
 *   | (constraintModel)       ^
 * +-+----+   * +-----+        |
 * | Tabs |-----| Tab | --- selected (mapped by name or empty constraint)
 * +------+     +-----+
 *
 */

define([
    "i18n/i18n",
    "utils/localStorage",
    "backbone",
    "underscore",
    "jquery"
  ], function (
    i18n,
    localStorage,
    Backbone,
    _,
    $
  ) {

  var setting = function (key, value) {
        var name = this.settingName(),
            storedValue = localStorage[name];

        try {
          storedValue = JSON.parse(storedValue);
        } catch (e) {
          storedValue = {};
        }

        if (typeof value === "undefined") {
          // get
          return key ? storedValue[key] : storedValue;
        } else {
          // set
          if (key) {
            storedValue[key] = value;
          } else {
            storedValue = value;
          }
          try {
            localStorage[name] = JSON.stringify(storedValue);
          } catch (e) {
          }
        }
      };

  var Tab = Backbone.Model.extend({

    initialize: function () {
      Backbone.Model.prototype.initialize.apply(this, arguments);
      this.listenTo(this, "destroy", this.destroy);
    },

    destroy: function () {
      this.stopListening();
      Backbone.Model.prototype.destroy.apply(this, arguments);
      this.removeSettings();
    },

    get: function (key, options) {
      options = options || {};
      options.localize = options.localize === false ? false : true;
      var value = Backbone.Model.prototype.get.apply(this, arguments);
      if (options.localize && key === "name") {
        value = i18n(value);
      }
      return value;
    },

    set: function (key) {
      var settings;
      if (key === "name") {
        settings = this.setting();
        this.removeSettings();
      }
      Backbone.Model.prototype.set.apply(this, arguments);
      if (settings) {
        this.setting(null, settings);
      }
    },

    isCustomTab: function () {
      return !!this.get("customTab");
    },

    isDataSourceTab: function () {
      return !!this.get("_dataSourceTab");
    },

    settingName: function () {
      return "tabs." + (this.id || this.get("name", { localize: false }));
    },

    setting: setting,

    removeSettings: function () {
      localStorage.removeItem(this.settingName());
    }

  });

  return Backbone.Collection.extend({
    model: Tab,

    initialize: function (models, options) {
      this.options = options;
      this.constraintsModel = options.constraintsModel;
      this.listenTo(this.constraintsModel, "change", this.update);
      this.listenTo(this, "add", this.update);
      this.listenTo(this, "remove", this.update);
      this.update();
    },

    save: function () {
    },

    update: function () {
      var hasQuery = !!this.constraintsModel.get("view");
      var selectedTabName = this.constraintsModel.get("view.name");
      var foundModel = null;

      _.each(this.models, function (model) {
        var selected = model.get("name", { localize:false }) === selectedTabName || (!hasQuery && !model.get("constraint"));
        model.set("selected", selected);
        if (selected) {
          foundModel = model;
        }
      });

      if (!foundModel) {
        this.options.application.selectFirstTab();
      } else {
        $(this.options.application.rootEls).attr("data-enabled-view", foundModel.get("name", { localize: false }) || "Everything");
      }
    },

    getByName: function (name, options) {
      var x = this.find(function (tab) {
        return tab.get("name", options) === name;
      });
      if (!x && !options) {
        x = this.getByName(name, {localize:false});
      }
      return x;
    },

    getSelectedTab: function () {
      var selected = this.find(function (tab) {
        return tab.get("selected");
      });
      return selected;
    },
    
    getSelectedTabName: function () {
      var selected = this.getSelectedTab();
      if (selected) return selected.get("name");
    },

    settingName: function () {
      return "tabs.__global__";
    },

    setting: function (key, value) {
      var tab = this.getSelectedTab();

      if (tab) {
        return tab.setting(key, value);
      } else {
        return setting.apply(this, arguments);
      } 
    }

  });

})

